(function() {
  function initPresseSection(section) {
    var track = section.querySelector('.presse__logos-track');
    var viewport = section.querySelector('.presse__logos-viewport');
    var logos = section.querySelectorAll('.presse__logo');
    var quotes = section.querySelectorAll('.presse__quote');
    var prevBtn = section.querySelector('.presse__nav--prev');
    var nextBtn = section.querySelector('.presse__nav--next');

    if (!track || logos.length === 0 || quotes.length === 0) return;

    var total = parseInt(section.querySelector('.presse__layout-2').dataset.total, 10);
    var currentIndex = 0;
    var visualPosition = total;
    var logoWidth = 128;
    var gap = window.innerWidth >= 990 ? 54 : 24;
    var isAnimating = false;

    function calculateOffset(position) {
      var itemFullWidth = logoWidth + gap;
      var viewportWidth = viewport.offsetWidth;
      var offset = (position * itemFullWidth) + (logoWidth / 2) - (viewportWidth / 2);
      return -offset;
    }

    function updateActiveStates(index) {
      logos.forEach(function(logo, i) {
        var logoIndex = i % total;
        logo.classList.toggle('presse__logo--active', logoIndex === index);
      });

      quotes.forEach(function(quote, i) {
        quote.classList.toggle('presse__quote--active', i === index);
      });
    }

    function goTo(direction) {
      if (isAnimating) return;

      isAnimating = true;
      visualPosition += direction;
      currentIndex += direction;

      if (currentIndex < 0) currentIndex = total - 1;
      if (currentIndex >= total) currentIndex = 0;

      updateActiveStates(currentIndex);

      var offset = calculateOffset(visualPosition);
      track.style.transform = 'translateX(' + offset + 'px)';
    }

    function resetPosition() {
      var minPos = 0;
      var maxPos = total * 3 - 1;
      var middleStart = total;
      var middleEnd = total * 2 - 1;

      if (visualPosition < middleStart || visualPosition > middleEnd) {
        track.style.transition = 'none';
        visualPosition = total + currentIndex;
        var offset = calculateOffset(visualPosition);
        track.style.transform = 'translateX(' + offset + 'px)';
        track.offsetHeight;
        track.style.transition = '';
      }

      isAnimating = false;
    }

    track.addEventListener('transitionend', resetPosition);

    logos.forEach(function(logo) {
      logo.addEventListener('click', function() {
        if (isAnimating) return;
        var idx = parseInt(this.getAttribute('data-index'), 10);
        var diff = idx - currentIndex;

        if (diff === 0) return;

        isAnimating = true;
        visualPosition += diff;
        currentIndex = idx;

        updateActiveStates(currentIndex);

        var offset = calculateOffset(visualPosition);
        track.style.transform = 'translateX(' + offset + 'px)';
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goTo(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goTo(1);
      });
    }

    window.addEventListener('resize', function() {
      gap = window.innerWidth >= 990 ? 54 : 24;
      var offset = calculateOffset(visualPosition);
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + offset + 'px)';
      track.offsetHeight;
      track.style.transition = '';
    });

    updateActiveStates(0);
    var offset = calculateOffset(visualPosition);
    track.style.transition = 'none';
    track.style.transform = 'translateX(' + offset + 'px)';
    track.offsetHeight;
    track.style.transition = '';
  }

  function init() {
    document.querySelectorAll('[data-section-type="presse"]').forEach(initPresseSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('[data-section-type="presse"]')) {
      init();
    }
  });
})();
